import { render, staticRenderFns } from "./EditTrainingModule.vue?vue&type=template&id=9347a43c&scoped=true&"
import script from "./EditTrainingModule.vue?vue&type=script&lang=ts&"
export * from "./EditTrainingModule.vue?vue&type=script&lang=ts&"
import style0 from "./EditTrainingModule.vue?vue&type=style&index=0&id=9347a43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9347a43c",
  null
  
)

/* custom blocks */
import block0 from "./EditTrainingModule.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports